__turbopack_context__.v({
  "className": "azeret_mono_88ff3bdd-module__TT_UYG__className",
  "variable": "azeret_mono_88ff3bdd-module__TT_UYG__variable",
});
